import { useEffect, useState, useRef, useCallback } from 'react';
import ReactModal from 'react-modal';

import Button from 'components/ui/button';
import { useModal } from 'context/ModalContext';
import { GetBehaviorDescription, GetBehaviorLabel, GetBehaviorText } from 'utils/strings';
import { Colaboracao, Inovacao, FocoNoCliente, Resolutividade, Lideranca } from 'components/icons';

const iconSize = 120;

const Behaviors: any = {
  colaboracao: <Colaboracao size={iconSize} />,
  inovacao: <Inovacao size={iconSize} />,
  foco: <FocoNoCliente size={iconSize} />,
  resolutividade: <Resolutividade size={iconSize} />,
  lideranca: <Lideranca size={iconSize} />,
};

export function ComportamentoHelpModal(props: any) {
  // const modalID = "achievement";

  const modalID = 'comportamento-help';

  const [modalIsOpen, setIsOpen] = useState(false);

  const { openModal, modalData, closeModal } = useModal();

  const modalRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const previousActiveElement = useRef<HTMLElement | null>(null);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    closeModal();
  }

  function afterOpenModal() {
    // Salva o elemento que estava focado antes de abrir o modal
    previousActiveElement.current = document.activeElement as HTMLElement;
    // Foca no botão de fechar ao abrir o modal
    setTimeout(() => {
      closeButtonRef.current?.focus();
    }, 100);
  }

  // Trap de foco dentro do modal
  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      closeModal();
      return;
    }

    if (e.key !== 'Tab') return;

    const focusableElements = modalRef.current?.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (!focusableElements || focusableElements.length === 0) return;

    const firstElement = focusableElements[0] as HTMLElement;
    const lastElement = focusableElements[focusableElements.length - 1] as HTMLElement;

    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }, [closeModal]);

  useEffect(() => {
    setIsOpen(openModal === modalID);

    // Retorna o foco ao elemento anterior quando o modal fecha
    if (openModal !== modalID && previousActiveElement.current) {
      previousActiveElement.current.focus();
    }
  }, [openModal]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel={`Saiba mais sobre ${GetBehaviorLabel(modalData)}`}
        portalClassName="relative z-40"
        overlayClassName="fixed z-40 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
        contentElement={() => (
          <>
            {/* {modalData === 'inovacao' && <Tesouro id="mandou" x={80} y={6} />} */}
            <div
              ref={modalRef}
              role="dialog"
              aria-modal="true"
              aria-labelledby="comportamento-modal-title"
              onKeyDown={handleKeyDown}
            >
              <div className="max-w-[800px] bg-blue-dark text-white rounded-xl p-10 space-y-2 flex flex-col items-center flex-none mx-5">
                <div className="text-center mb-3">
                  <h1 id="comportamento-modal-title" className="text-yellow text-2xl mb-2" tabIndex={0}>
                    Saiba mais sobre {GetBehaviorLabel(modalData)}
                  </h1>
                </div>

                <div aria-hidden="true">
                  {Behaviors[modalData]}
                </div>

                <div className="max-h-[32vh] overflow-y-auto space-y-4" tabIndex={0}>
                  <div
                    className="text-lg text-blue-light"
                    dangerouslySetInnerHTML={{
                      __html: GetBehaviorDescription(modalData),
                    }}
                  ></div>

                  <div
                    dangerouslySetInnerHTML={{
                      __html: GetBehaviorText(modalData),
                    }}
                  ></div>
                </div>
                <div className="pt-3">
                  <Button ref={closeButtonRef} onClick={() => closeModal()} arialabel="Fechar modal">FECHAR</Button>
                </div>
              </div>
            </div>
          </>
        )}
      />
    </>
  );
}
